import { useParams } from "react-router-dom"
import { LineaTemplate } from "../components/LineaTemplate/LineaTemplate"

export const LineaInvestigacion = (props) =>{

    const {name} = useParams()

    return(
        <LineaTemplate linea={name} {...props}> </LineaTemplate>
    )
}